export const VOTES_TYPES = {
  בעד: 1,
  נגד: 2,
  נמנע: 3,
};

export const ALL_KNESSET_NUMBERS = {
  "השש-עשרה": 16,
  "השבע-עשרה": 17,
  "השמונה-עשרה": 18,
  "התשע-עשרה": 19,
  העשרים: 20,
  "העשרים ואחת": 21,
  "העשרים ושתיים": 22,
  "העשרים ושלוש": 23,
  "העשרים וארבע": 24,
  "העשרים וחמש": 25,
};
